exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-persistent-banner{display:flex;align-items:center;height:40px;color:#fff;font-size:.875rem}.ba-persistent-banner .ba-persistent-banner-child{display:flex;align-items:center;padding-left:16px;height:100%}", ""]);

// exports
exports.locals = {
	"persistentBannerClassName": "\"ba-persistent-banner\"",
	"persistentBannerChildClassName": "\"ba-persistent-banner-child\""
};